import { render, staticRenderFns } from "./UserSalary.vue?vue&type=template&id=da33412e"
import script from "./UserSalary.vue?vue&type=script&lang=js"
export * from "./UserSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports